<template>
  <FormBody :number="2">
    <div class="container">
      <form @submit.prevent="onSubmit" enctype="multipart/form-data" ref="mainForm">
        <input type="hidden" name="personalFormType" :value="personalFormType">

        <InputWithLabel
            type="text"
            name="personalLastName"
            :errors="v$.personalLastName.$errors"
            v-model="personalLastName"
            @blur="v$.personalLastName.$touch"
            scroll-into-view-if-errors
        >
          Фамилия*
        </InputWithLabel>

        <InputWithLabel
            type="text"
            name="personalName"
            :errors="v$.personalName.$errors"
            v-model="personalName"
            @blur="v$.personalName.$touch"
            scroll-into-view-if-errors
        >
          Имя*
        </InputWithLabel>


        <InputWithLabel
            type="text"
            name="personalPatronymic"
            :errors="v$.personalPatronymic.$errors"
            v-model="personalPatronymic"
            @blur="v$.personalPatronymic.$touch"
            scroll-into-view-if-errors
        >
          Отчество*
        </InputWithLabel>

        <InputWithLabel
            type="email"
            name="personalEmail"
            :errors="v$.personalEmail.$errors"
            v-model="personalEmail"
            @blur="v$.personalEmail.$touch"
            scroll-into-view-if-errors
        >
          E-MAIL*
        </InputWithLabel>

        <div class="form-group">
          <label class="form-label">Банк*</label>
          <CustomSelect name="personalBank" @initialize="onInitialize" @itemSelected="onItemSelected">
            <option value="RosbankAuto">Росбанк Авто</option>
            <option value="Rosbank">РОСБАНК</option>
            <option value="RosbankBranch">Филиал ПАО РОСБАНК Росбанк Дом</option>
            <option value="Other">Другой</option>
          </CustomSelect>
        </div>

        <div class="form-group">
          <label class="form-label">Номер договора</label>
          <input name="personalContractNumber" type="text" class="form-text" v-model="personalContractNumber">
        </div>

        <div class="form-group">
          <label class="form-label">Текст обращения*</label>
          <textarea v-model="personalAppeal" name="personalAppeal" class="form-textarea" rows="6"></textarea>
          <p
              v-for="(error, index) of v$.personalAppeal.$errors"
              :key="index"
          ><strong class="error-message">{{error.$message}}</strong></p>
        </div>

        <UploadFiles/>

        <div class="checkbox-group">
          <div class="label-checkbox-pair">
            <input id="personalAgree" name="personalAgree" type="checkbox" v-model="personalAgree" @click="onAgreeChange">
            <label for="personalAgree">Я ознакомился с политикой обработки персональных данных (ПД) и даю согласие на обработку ПД.</label>
            <input type="hidden" :value="personalAgree">
          </div>
        </div>
        <vue-recaptcha v-model="captchaPassed" />
        <div class="feedback-buttons-wrap">
          <router-link :to="{name : 'home'}" class="feedback__back">Назад</router-link>
          <button type="submit" :class="{'feedback__button': true, 'feedback__button-disabled':notReadyToSend}" :disabled="notReadyToSend">Отправить</button>
        </div>
      </form>
    </div>
  </FormBody>
</template>

<script>
import UploadFiles from "@/components/utils/UploadFiles";
import * as mns from "@/store/mutation-types";
import useVuelidate from "@vuelidate/core";
import {email, helpers, required} from "@vuelidate/validators";
import FormBody from "@/components/utils/FormBody";
import {checked} from "@/validators/checkbox-validators";
import InputWithLabel from "@/components/utils/InputWithLabel";
import CustomSelect from "@/components/utils/CustomSelect";
import sendForm from "@/mixins/sendForm";
import VueRecaptcha from '@/components/utils/VueRecaptcha.vue';

export default {
  mixins: [sendForm],
  name: "PersonalDataForm",
  components: {InputWithLabel, UploadFiles, CustomSelect, FormBody, VueRecaptcha},
  data(){
    return {
      v$: useVuelidate(),
      captchaPassed: false
    };
  },
  watch: {
    'v$.$silentErrors': function (errors) {
      if(this.personalAgree && errors.length > 0){
        this.personalAgree = false;
      }
    }
  },
  validations(){
    return {
      personalLastName: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      personalName: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      personalPatronymic: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      },
      personalEmail: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
        email: helpers.withMessage('Неверный формат', email),
      },
      personalAppeal: {
        required: helpers.withMessage('Поле должно быть заполнено', required),
      },
      personalAgree: {
        checked,
      }
    }
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_PERSONAL_BANK, event.getValue().value);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_PERSONAL_BANK, choice.value);
    },
    onSubmit(){
      // Валидируем форму.
      this.v$.$validate();

      // Если есть ошибки, то выходим из функции.
      if(this.v$.$error){
        return;
      } // if.

      // Получаем ссылку на форму.
      const mainForm = this.$refs.mainForm;

      // Отправляем данные на сервер.
      this.sendForm('send-other-types-request-emails', mainForm)

      this.$router.push({name :'RequestSent'});
    },
    onAgreeChange(){
      if(!this.personalAgree){
        this.v$.$touch();

        let firstElementWithError = this.v$.$silentErrors[0];

        if(firstElementWithError){
          document
              .getElementsByName(firstElementWithError.$property)[0]
              .scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
        } // if.
      } // if.
    },
  },
  computed: {
    notReadyToSend(){
      return !this.personalAgree || !this.captchaPassed || this.waitResponse
    },
    personalFormType: {
      get(){
        return this.$store.getters.personalFormType;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_FORM_TYPE, value);
      },
    },
    personalLastName: {
      get(){
        return this.$store.getters.personalLastName;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_LAST_NAME, value)
      }
    },
    personalName: {
      get(){
        return this.$store.getters.personalName;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_NAME, value)
      }
    },
    personalPatronymic: {
      get(){
        return this.$store.getters.personalPatronymic;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_PATRONYMIC, value)
      }
    },
    personalEmail: {
      get(){
        return this.$store.getters.personalEmail;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_EMAIL, value)
      }
    },
    personalContractNumber: {
      get(){
        return this.$store.getters.personalContractNumber;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_CONTRACT_NUMBER, value)
      }
    },
    personalAppeal: {
      get(){
        return this.$store.getters.personalAppeal;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_APPEAL, value)
      }
    },
    personalAgree: {
      get(){
        return this.$store.getters.personalAgree;
      },
      set(value){
        this.$store.commit(mns.SET_PERSONAL_AGREE, value)
      }
    },
  }
}
</script>

<style scoped>
.container{
  padding: 25px 50px;
}

.feedback-buttons-wrap{
  display: flex;
  margin: 40px auto;
  flex-wrap: wrap;
}

.feedback__back{
  height: 45px!important;
  padding: 0!important;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #e60028;
  -webkit-box-flex: 0;
  flex: 0 0 25%;
  margin: 0 10px 0 0!important;
  position: relative;
  color: #333;
  z-index: 1;
  overflow: hidden;
  -webkit-transition: all .5s;
  transition: all .5s;
}
.feedback__button{
  background: #e60028;
  height: 45px!important;
  margin: 0!important;
  padding: 0!important;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  border-radius: 5px;
  border: 1px solid transparent;
  color: #fff;
}

.feedback__button-disabled{
  background: #fc6270;
}
</style>
